var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoMen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 35,
    viewBox: "0 0 54 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "two-men",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M37.818,33V27.107a9.72,9.72,0,0,0-4.727-8.015,8.883,8.883,0,0,1,2.363-.236c5.436,0,16.546,2.829,16.546,8.25V33ZM0,33V27.107c0-5.422,11.109-8.25,16.546-8.25s16.546,2.829,16.546,8.25V33ZM28.364,7.071a7.091,7.091,0,0,1,14.182,0,7.091,7.091,0,0,1-14.182,0Zm-18.909,0A6.955,6.955,0,0,1,16.546,0a6.955,6.955,0,0,1,7.091,7.071,6.955,6.955,0,0,1-7.091,7.071A6.954,6.954,0,0,1,9.455,7.071Z",
    fill: "none",
    stroke: "#7ab737",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoMen);
export default __webpack_public_path__ + "static/media/two-men.3f1dbd681f1f5dd8148875ce6d5aba0d.svg";
export { ForwardRef as ReactComponent };